import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id ADB52436-4BAD-40E2-8A13-48C76188FCE6
 * name vector-polyline-minus
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-polyline-minus.svg
 * tags
 */
export const VectorPolylineMinusIcon = createSvgIcon(<><path d="M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3H2M4 5H6V7H4V5M18 7H20V9H18V7M8 17H10V19H8V17M15 18V20H23V18H15Z" /></>, 'VectorPolylineMinusIcon');
export default VectorPolylineMinusIcon